import React from 'react';
import AppRoot from "./AppRoot";
import AppLoader from "./AppLoader";

function App(){
  return(
    <AppRoot>
      <AppLoader />
    </AppRoot>
  )
}

export default App;